/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Ergebnisse gefunden`
};

const en_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `No results found`
};

const es_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `No se ha encontrado ningún resultado`
};

const fr_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun résultat trouvé`
};

const it_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun risultato trovato`
};

const nl_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `Geen resultaten gevonden`
};

const pt_search_tools__messages__empty = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum resultado encontrado`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_tools__messages__empty(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_tools__messages__empty", locale)
	if (locale === "de") return de_search_tools__messages__empty(inputs)
	if (locale === "en") return en_search_tools__messages__empty(inputs)
	if (locale === "es") return es_search_tools__messages__empty(inputs)
	if (locale === "fr") return fr_search_tools__messages__empty(inputs)
	if (locale === "it") return it_search_tools__messages__empty(inputs)
	if (locale === "nl") return nl_search_tools__messages__empty(inputs)
	return pt_search_tools__messages__empty(inputs)
};